import { get, has, isEmpty } from 'lodash';
import {
	editCapabilities,
	TYPE_BACS_CREDIT,
	TYPE_BACS_DEBIT,
	TYPE_CHAPS,
	CHAPS_IFT_BACS_AmountLimit,
	amountLimit,
	exoticAmountLimit,
	TYPE_IFT,
	TYPE_FASTER_PAYMENTS,
} from '../../config';

export const hasGroupApprovalsEnabled = (state) => Boolean(state.modes.hasGroupApprovalsEnabled);
export const hasPaymentCapability = (state) => Boolean(state.modes.hasPaymentCapability);
export const isMultiTransactions = (state) => Boolean(state.modes.multiTransactions);
export const isAuthorisationEdit = (state) => Boolean(state.modes.isAuthorisationEdit);
export const isManagePaymentEdit = (state) => Boolean(state.modes.isManagePaymentEdit);
export const isAuthorisationEditById = (state) => Boolean(state.modes.isAuthorisationEditById);
export const getIsLCV = (state) => Boolean(state.modes.lcv);
export const canAddMultiplePayees = (state) => Boolean(state.modes.canAddMultiplePayees);
export const getIsAddingNewRow = (state) => Boolean(state.modes.isAddingNewRow);

export const isPaymentInEditMode = (state) =>
	isManagePaymentEdit(state) || isAuthorisationEdit(state) || isAuthorisationEditById(state);

export const getEditMode = (state) => state.modes.editMode;
export const getPaymentType = (state) => get(state, 'modes.paymentType', '');
export const getPaymentTypeOrPayeeType = (state) => getPaymentType(state) || get(state, 'managePayee.payeeType', '');

export const canAddPaymentWhenEditing = (state) => {
	const editMode = getEditMode(state);
	return editCapabilities[editMode].add;
};

export const isChaps = (state) => state.modes.paymentType === TYPE_CHAPS;
export const isIFT = (state) => state.modes.paymentType === TYPE_IFT;
export const calcMaxAmountForPaymentType = (state, isPayee) => {
	if ([TYPE_CHAPS, TYPE_BACS_CREDIT, TYPE_BACS_DEBIT].includes(state.modes.paymentType)) {
		return CHAPS_IFT_BACS_AmountLimit;
	}

	if (TYPE_FASTER_PAYMENTS === state.modes.paymentType && !isPayee) return exoticAmountLimit;
	return amountLimit;
};
